import React, { useState } from "react";
import { useIntl } from "react-intl";
import { AutoCompleteCreate } from "@/model";
import { useCreateAutocomplete } from "@/query/autocomplete";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { TextInputGroup } from "@/component/input";
import { errorToast, successToast } from "@/component/Toast";


export const AUTOCOMPLETE_CREATE_MODAL_ID = "autocomplete-create-modal-id";

const AutocompleteCreateModal: React.FC = () => {
    const intl = useIntl();
    const agentId = useAgentId();
    const modal = useModal();

    const [validation, setValidation] = useState<boolean>(true);
    const [name, setName] = useState<string>("");

    const { mutateAsync: createAutocomplete, isPending: isCreating } = useCreateAutocomplete(agentId);

    const onClickCancel = () => {
        modal.close(AUTOCOMPLETE_CREATE_MODAL_ID);
    };

    const onClickConfirm = async () => {
        const isValid = !!name && name.trim().length > 0;
        setValidation(isValid);
        if (!isValid) {
            return;
        }

        const form: AutoCompleteCreate = {
            agent_id: agentId,
            name: name,
        };
        await createAutocomplete(form)
            .then(() => {
                successToast(intl.formatMessage({ id: "t001" }));
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            })
            .finally(() => {
                modal.close(AUTOCOMPLETE_CREATE_MODAL_ID);
            });
    };

    return (
        <Modal id={AUTOCOMPLETE_CREATE_MODAL_ID}
               size="sm"
               title={intl.formatMessage({ id: "i08006" })}
               onClose={() => {
                    setName("");
                    setValidation(true);
               }}
        >
            <div className="modal-body">
                <TextInputGroup defaultValue=""
                                placeholder={intl.formatMessage({ id: "i08007" })}
                                invalid={!validation}
                                onChange={setName}
                />
                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            disabled={isCreating}
                            onClick={onClickCancel}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            disabled={isCreating}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AutocompleteCreateModal;